module.exports = __webpack_public_path__ + "static/media/download-blue.8e6bbc7f.svg";